// ======================================================================
// File Name       : ServiceTopContainer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================
import React from 'react';
import { Col } from 'react-bootstrap';
import { connect } from 'react-redux';
import { serviceSearch } from '../../actions/ServiceAction';
import DialogConfirm from '../../components/DialogConfirm';
import Header from '../../components/Header';
import MessageSearch from '../../components/MessageSearch';
import CustomLink from '../../components/button/CustomLink';
import ServiceList from '../../components/service/ServiceList';
import ServiceSearch from '../../components/service/ServiceSearch';
import { DORMANT_STATE, RETURN_MAX_NUM, SELECT_TARGET_DATA } from '../../constants';
import { SERVICE_REGISTER } from '../../constants/FunctionConstants';
import * as MessageTemplate from '../../constants/MessageTemplate';
import * as Path from '../../constants/PathConstants';
import * as actionType from '../../constants/actionTypes/page';
import { LO_SUPER_USER } from '../../constants/index';
import { canAccessRoute } from '../../utils/AuthedUtils';

class ServiceTopContainer extends React.Component {
  constructor() {
    super();
    this.state = {
      showModal: false,
      serviceSearchInfo: {
        serviceName: '',
        serviceCd: '',
        enterpriseName: '',
        dormantState: DORMANT_STATE.INACTIVE,
        courseType: true,
        contentType: true,
        serviceSortType: null,
        ascendingDescendingSort: 0,
        startPosition: 0,
      },
      isAllowShowSearchMessage: false,
      isInit: false,
      returnMaxNum: RETURN_MAX_NUM,
      serviceInfo: null,
      currentSearch: {
        dormantState: DORMANT_STATE.INACTIVE,
        courseType: true,
        contentType: true,
        serviceSortType: null,
        ascendingDescendingSort: 0,
        startPosition: 0,
      },
    };
    this.onSearchData = this.onSearchData.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.serviceTypeHandleChange = this.serviceTypeHandleChange.bind(this);
    this.handleChangeForDormantFlag = this.handleChangeForDormantFlag.bind(this);
    this.onCSVExportCancel = this.onCSVExportCancel.bind(this);
    this.onCSVExportOk = this.onCSVExportOk.bind(this);
    this.handleSortState = this.handleSortState.bind(this);
    this.getStartEndData = this.getStartEndData.bind(this);
    this.dismissMessage = this.dismissMessage.bind(this);
    this.handleMouseEnter = this.handleMouseEnter.bind(this);
    this.handleMouseLeave = this.handleMouseLeave.bind(this);
  }

  componentWillMount() {
    if (this.props.parentPath === Path.SERVICE_LIST) {
      this.setState({
        ...this.state,
        currentSearch: this.props.searchCondition,
        serviceSearchInfo: this.props.searchCondition,
        isInit: false,
      });
    }
  }

  componentDidMount() {
    this.getServiceList(SELECT_TARGET_DATA.DATA);
  }

  componentWillReceiveProps(nextProps) {
    const { service } = nextProps;
    const { serviceInfo } = service;
    this.setState({
      serviceInfo,
    });
  }

  componentWillUnmount() {
    const searchCondition = this.state.currentSearch;
    searchCondition.startPosition = this.state.serviceSearchInfo.startPosition;
    searchCondition.serviceSortType = this.state.serviceSearchInfo.serviceSortType;
    searchCondition.ascendingDescendingSort = this.state.serviceSearchInfo.ascendingDescendingSort;
    this.props.dispatch({
      type: actionType.SAVE_SEARCH_CONDITION,
      parentPath: Path.SERVICE_LIST,
      searchCondition,
    });
  }

  /**
   * Get service list when click button search
   */
  onSearchData() {
    const serviceSearchInfo = {
      ...this.state.serviceSearchInfo,
      ...{ startPosition: 0 },
      ...{ serviceSortType: null },
      ...{ ascendingDescendingSort: 0 },
    };
    const currentSearch = {
      ...this.state.serviceSearchInfo,
      ...(this.state.currentSearch = this.state.serviceSearchInfo),
    };
    this.setState({
      serviceSearchInfo,
      currentSearch,
      isInit: false,
    }, () => {
      this.getServiceList(SELECT_TARGET_DATA.DATA).then(() => {
        if (!this.state.isInit) {
          this.setState({ isAllowShowSearchMessage: true });
        }
      });
    });
  }

  /**
     * Get service list
     *
     * @param {integer} selectTargetData
     */
  getServiceList(selectTargetData) {
    const { serviceSearchInfo, returnMaxNum, serviceSortType, currentSearch } = this.state;
    const serviceTypes = [];
    if (currentSearch.courseType) serviceTypes.push(0);
    if (currentSearch.contentType) serviceTypes.push(2);
    if (serviceTypes.length === 0) {
      // Just get service with service type = 0 or 2
      serviceTypes.push(0);
      serviceTypes.push(2);
    }
    const param = {
      selectTargetData,
      searchInfo: {
        ascendingDescendingSort: this.state.serviceSearchInfo.ascendingDescendingSort,
        startPosition: this.state.serviceSearchInfo.startPosition,
      },
    };
    !isNaN(parseInt(serviceSortType, 10))
      && (param.searchInfo.serviceSortType = this.state.serviceSearchInfo.serviceSortType);
    !isNaN(parseInt(returnMaxNum, 10))
      && (param.searchInfo.returnMaxNum = returnMaxNum);
    if (serviceTypes && serviceTypes.length > 0) {
      param.searchInfo.serviceTypeList = serviceTypes;
    }
    if (currentSearch.dormantState !== DORMANT_STATE.INACTIVE) {
      param.searchInfo.dormantState = DORMANT_STATE.ACTIVE;
    }

    if (currentSearch.serviceCd) {
      param.searchInfo.serviceCdList = currentSearch.serviceCd.split(',');
    }
    if (currentSearch.serviceName) {
      param.searchInfo.serviceName = currentSearch.serviceName;
    }
    if (currentSearch.enterpriseName) {
      param.searchInfo.enterpriseName = currentSearch.enterpriseName;
    }
    if (currentSearch.serviceSortType !== -1) {
      param.searchInfo.serviceSortType = serviceSearchInfo.serviceSortType;
    }
    return this.props.dispatch(serviceSearch(param));
  }

  /**
     * handle change for user input
     * @param {*} event
     */
  handleChange(event) {
    const { name, value } = event.target;
    const serviceSearchInfo = { ...this.state.serviceSearchInfo, ...{ [name]: value } };
    this.setState({ serviceSearchInfo });
  }

  /**
     * handle change for service type
     * @param {*} event
     */
  serviceTypeHandleChange(event) {
    const { name, checked } = event.target;
    const serviceSearchInfo = { ...this.state.serviceSearchInfo, ...{ [name]: checked } };
    this.setState({ serviceSearchInfo });
  }

  /**
     * handle change for dormant flag
     * @param {*} event
     */
  handleChangeForDormantFlag(event) {
    const { name, checked } = event.target;
    const serviceSearchInfo = { ...this.state.serviceSearchInfo, ...{ [name]: checked ? 1 : 0 } };
    this.setState({
      serviceSearchInfo,
    });
  }

  /**
     * Open dialog confirm export CSV file
     */
  openCSVExportConfirm(mdContent, mdSize) {
    this.content = mdContent;
    this.mdSize = mdSize;
    this.setState({ showModal: true });
  }

  /**
     * handle on Cancel click to export CSV file
     */
  onCSVExportCancel() {
    this.setState({ showModal: false });
  }

  /**
     * handle on OK click to export CSV file
     */
  onCSVExportOk() {
    // ToDo: send data  etc ....
    this.setState({ showModal: false });
    this.getServiceList(SELECT_TARGET_DATA.CSV);
  }

  /**
     * Pagination
     * @param {*} page
     */
  getStartEndData(startPosition) {
    const serviceSearchInfo = {
      ...this.state.serviceSearchInfo,
      ...{ startPosition },
    };
    this.setState(
      {
        serviceSearchInfo,
      },
      () => {
        this.getServiceList(SELECT_TARGET_DATA.DATA);
      },
    );
  }

  /**
     * handle sorting data
     * @param {*} row
     */
  handleSortState(row) {
    const serviceSearchInfo = {
      ...this.state.serviceSearchInfo,
      serviceSortType: row.sortBy,
      ascendingDescendingSort: row.sortState,
    };
    this.setState(
      {
        serviceSearchInfo,
      },
      () => {
        this.getServiceList(SELECT_TARGET_DATA.DATA);
      },
    );
  }

  dismissMessage() {
    this.setState({ isAllowShowSearchMessage: false });
  }

  handleMouseEnter(index) {
    this.setState({
      hoverIndex: index,
    });
  }

  handleMouseLeave() {
    this.setState({
      hoverIndex: undefined,
    });
  }

  /**
   * Render function of component
   */
  render() {
    const { userInfo: { displayUserType }, readOnlyFlag } = this.props;
    const canEditService = canAccessRoute(SERVICE_REGISTER);
    const isSuperUserL0 = displayUserType === LO_SUPER_USER;
    const { hoverIndex } = this.state;
    const recordNum = this.props.serviceInfo ? this.props.serviceInfo.recordNum : 0;
    const serviceList = this.props.serviceInfo ? this.props.serviceInfo.serviceList : [];
    return (
      <div>
        <MessageSearch
          recordNum={recordNum}
          resultList={serviceList}
          isAllowShowSearchMessage={this.state.isAllowShowSearchMessage}
          dismissMessage={this.dismissMessage}
        />
        {/* Step 10.0.0 START */}
        <Col sm={12} className="padding-left-right-clear">
          <Col sm={3} className="padding-left-right-clear">
            <Header name="サービス管理" />
          </Col>
          <Col sm={9} className="margin-top-20 float-end padding-left-right-clear align-right align-self-center">
            <CustomLink
              className="link-authority bold inline-flex line-height-20"
              to={Path.SERVICE_GROUP_LIST}
              text="サービスグループ設定"
            />
          </Col>
        </Col>
        {/* Step 10.0.0 END */}
        <ServiceSearch
          {...this.state.serviceSearchInfo}
          handleInputChange={this.handleChange}
          serviceTypeHandleChange={this.serviceTypeHandleChange}
          handleChangeForDormantFlag={this.handleChangeForDormantFlag}
          onSearchBtnClick={this.onSearchData}
          onExportBtnClick={this.openCSVExportConfirm.bind(this, MessageTemplate.BULK_EXPORT, null)}
          isSuperUserL0={isSuperUserL0}
          readOnlyFlag = {readOnlyFlag}
          canEditService={canEditService}
        />
        <ServiceList
          serviceInfo={this.props.serviceInfo}
          handleSortState={this.handleSortState}
          serviceSearchInfo={this.state.serviceSearchInfo}
          getStartEndData={this.getStartEndData}
          recordNum={recordNum}
          startPosition={this.state.serviceSearchInfo.startPosition}
          handleMouseEnter={this.handleMouseEnter}
          handleMouseLeave={this.handleMouseLeave}
          hoverIndex={hoverIndex}
        />
        <DialogConfirm
          showModal={this.state.showModal}
          onCancel={this.onCSVExportCancel}
          mdSize={this.mdSize}
          content={this.content}
          onOK={this.onCSVExportOk}
        />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { parentPath, searchCondition } = state.page;
  const { userInfo, readOnlyFlag } = state.authed.authedUser;
  return ({
    ...{ service: state.service },
    parentPath,
    searchCondition,
    serviceInfo: state.serviceLogin.serviceInfo,
    userInfo,
    readOnlyFlag,
  });
};

export default connect(mapStateToProps)(ServiceTopContainer);
